import { Component, inject, input } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdvertiserCreationDialogComponent } from '../../modals/advertiser-creation-dialog/advertiser-creation-dialog.component';
import { AdvertiserService } from '~app/app/~shared/services/advertiser.service';
import { Advertiser } from '~core/models/advertiser.models';
import { AdvertiserDetailsComponent } from '../advertiser-details/advertiser-details.component';

@Component({
  selector: 'advertiser-datatable',
  templateUrl: './advertiser-datatable.component.html',
  styleUrl: './advertiser-datatable.component.scss'
})
export class AdvertiserListDatatableComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _advertiserService = inject(AdvertiserService);
  private _resourceFacade = inject(ResourceFacade);

  advertisers = input<Advertiser[]>([]);

  onRowClick(advertisers: Advertiser): void {
    const dialogRef = this._dialogService.open({
      component: AdvertiserDetailsComponent,
      config: {
        panelClass: ['mat-dialog-custom', 'w-[600px]'],
        backdropClass: ['bg-black/50'],
        disableClose: false,
        maxWidth: '600px'
      }
    });
    dialogRef.componentRef?.setInput('advertisers', advertisers);
  }

  displayedColumns: string[] = [
    'name',
    'country',
    'address',
    'email',
    'phoneNumber',
    'actions'
  ];

  openEditDialog(advertiser: Advertiser): Observable<unknown> {
    const dialogRef = this._dialogService.open({
      component: AdvertiserCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('advertiser', advertiser);

    return dialogRef.afterClosed();
  }

  openDeleteDialog(advertiser: Advertiser): void {
    const delete$ = this._advertiserService.remove(advertiser.id);

    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer l'annonceur "${advertiser.name}" ?`
    );

    dialogRef
      .afterClosed()
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Annonceur supprimé avec succès',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
